import {hasRole} from '../../utils/hasRole';
import React, {useEffect, useRef, useState} from 'react';
import {financePermissions} from '../../utils/financePermissions';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {TabView, TabPanel} from 'primereact/tabview';
import {BreadCrumb} from 'primereact/breadcrumb';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {SplitButton} from "primereact/splitbutton";
import axios from "axios";

import PartnerListComponent from "../../components/2.1/partner/PartnerListComponent";
import PartnerFormComponent from "../../components/2.0/partner/PartnerFormComponent";
import EmployeeListComponent from "../../components/2.1/hr/empoloyee/EmployeeListComponent";
import EmployeeFormComponent from "../../components/2.1/hr/empoloyee/EmployeeFormComponent";
import EmployeeDeactivateButton from "../../components/2.1/hr/empoloyee/EmployeeDeactivateButton";
import EmployeeShowComponent from "../../components/2.1/hr/empoloyee/EmployeeShowComponent";
import EmployeeHistoryComponent from "../../components/2.1/hr/empoloyee/EmployeeHistoryComponent";
import EmployeeRecordsComponent from "../../components/2.1/hr/empoloyee/EmployeeRecordsComponent";
import EmployeeUserAccountComponent from "../../components/2.1/hr/empoloyee/EmployeeUserAccountComponent";
import EmploymentListComponent from "../../components/2.1/hr/empoloyment/EmploymentListComponent";
import EmploymentFormComponent from "../../components/2.1/hr/empoloyment/EmploymentFormComponent";
import EmploymenttypeListComponent from "../../components/2.1/hr/empoloymenttype/EmploymenttypeListComponent";
import EmploymenttypeFormComponent from "../../components/2.1/hr/empoloymenttype/EmploymenttypeFormComponent";
import EmployeepositionListComponent from "../../components/2.1/hr/empoloyeeposition/EmployeepositionListComponent";
import EmployeepositionFormComponent from "../../components/2.1/hr/empoloyeeposition/EmployeepositionFormComponent";
import CitizenshipListComponent from "../../components/2.1/hr/citizenship/CitizenshipListComponent";
import CitizenshipFormComponent from "../../components/2.1/hr/citizenship/CitizenshipFormComponent";
import CalendarComponent from "../../components/2.1/hr/calendar/CalendarComponent";
import CalendarFormComponent from "../../components/2.1/hr/calendar/CalendarFormComponent";
import CalendarcategoryListComponent from "../../components/2.1/hr/calendar-category/CalendarcategoryListComponent";
import CalendarcategoryFormComponent from "../../components/2.1/hr/calendar-category/CalendarcategoryFormComponent";
import CompilanceFormComponent from "../../components/2.1/hr/compilance/CompilanceFormComponent";
import CompilanceListComponent from "../../components/2.1/hr/compilance/CompilanceListComponent";
import DocsListComponent from "../../components/2.1/docs/DocsListComponent";
import DocsFormComponent from "../../components/2.1/docs/DocsFormComponent";
import CompilancecategoryListComponent
  from "../../components/2.1/hr/compilance-category/CompilancecategoryListComponent";
import CompilancecategoryFormComponent
  from "../../components/2.1/hr/compilance-category/CompilancecategoryFormComponent";
import DocsUploadComponent from "../../components/2.1/docs/DocsUploadComponent";
import CheckinListComponent from "../../components/2.1/hr/checkin/CheckinListComponent";
import PayrollFormComponent from '../../components/2.1/hr/payroll/PayrollFormComponent';
import PayrollListComponent from '../../components/2.1/hr/payroll/PayrollListComponent';
import ImportListComponent from "../../components/2.1/import/ImportListComponent";
import ImportFormComponent from "../../components/2.1/import/ImportFormComponent";
import CheckinexportFormComponent from '../../components/2.1/hr/checkin/CheckinexportFormComponent';
import CheckinexportListComponent from '../../components/2.1/hr/checkin/CheckinexportListComponent';
import PayrollexportFormComponent from '../../components/2.1/hr/payroll/PayrollexportFormComponent';
import PayrollexportListComponent from '../../components/2.1/hr/payroll/PayrollexportListComponent';
import HrDashboardComponent from '../../components/2.1/hr/HrDashboardComponent';
import PayrollentryListComponent from '../../components/2.1/hr/payrollentry/PayrollentryListComponent';
import PayrollShowComponent from '../../components/2.1/hr/payroll/PayrollShowComponent';
import PayrollCostallocationListComponent from '../../components/2.1/hr/payroll/PayrollCostallocationListComponent';
import PayrollitemListComponent from '../../components/2.1/hr/payrollitem/PayrollitemListComponent';
import SimplifiedEmploymentListComponent from '../../components/2.1/hr/simplified-employment/SimplifiedEmploymentListComponent';

export const HrPage = (props) => {

  const history = useHistory();
  const {t} = props;
  const {entity, action, id} = useParams();
  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchActive, setDetailedSearchActive] = useState(false);
  const [employeeData, setEmployeeData] = useState(null);
  const [employeeDashboardId, setEmployeeDashboardId] = useState(null);
  const [payrollData, setPayrollData] = useState(null);
  const [payroll, setPayroll] = useState(null);
  const [compilanceCategory, setCompilanceCategory] = useState([]);
  const complianceSplitButtonRef = useRef(null);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const baseHrPath =
    '/hr/' +
    entity + '/' +
    action +
    (id && id !== 'undefined' ? '/' + id : '');

  useEffect(() => {
    document.title = 'HR' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('hr')[0]) {
        document.getElementsByClassName('hr')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerenderHrPage]);

  useEffect(() => {
    if (entity !== 'employee' && action !== 'read') return;
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/employee-compliance-category', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
        setCompilanceCategory(response.data.data.items)
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
  }, [entity, id, action]);

  useEffect(() => {
    if (entity === 'payroll' && id && action === 'read') {
      apiCall('get', '/api/v2/payroll/' + id)
        .then(response => {
          setPayrollData(response?.data?.data || null);
        })
        .catch(() => {
          setPayrollData(null);
        });
    }
  }, [entity, id, action, window.App.state.rerenderHrPage]);

  return (
    <div className={"HrPage"}>
      {localStorage.getItem('module_hr') ? (
        <>
          {entity === 'dashboard' && hasRole('ROLE_HR_MODULE_DASHBOARD') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <HrDashboardComponent />
            </div>
          }
          {entity === 'employee' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_employee_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('employeeList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <Button
                    type="button"
                    label={t('detailedSearch')}
                    icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                    className="p-button-outlined p-mr-2"
                    onClick={() => setDetailedSearchVisible(v => !v)}
                  />
                  {localStorage.getItem('roles').toString().includes('role_employee_write') && (
                    <a onClick={() => {
                      history.push('/hr/employee/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEmployee')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <EmployeeListComponent
                  backlink={'/hr/employee'}
                  detailedSearchVisible={detailedSearchVisible}
                  onDetailedSearchActiveChange={setDetailedSearchActive}
                />
              </Panel>
            </div>
          }
          {entity === 'employee' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'employee') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={entity === 'employee' && (action === 'create' || action === 'update' || window.App.urlVars().update === 'employee')}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/employee')
                       }
                       if (window.App.urlVars().update === 'employee') {
                         history.push('/hr/' + entity + '/' + action + '/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('employeeUpdate') : t('employeeCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/employee')
                      }
                      if (window.App.urlVars().update === 'employee') {
                        history.push('/hr/' + entity + '/' + action + '/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <EmployeeFormComponent backlink={'/hr/employee'}/>
                  }
                  {window.App.urlVars().update === 'employee' &&
                    <EmployeeFormComponent backlink={'/hr/' + entity + '/' + action + '/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }

          {((entity === 'employment' && (action === 'create' || action === 'update')) || (entity === 'employee' && (window.App.urlVars().create === 'employment' || window.App.urlVars().update === 'employment'))) &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'employment' || window.App.urlVars().update === 'employment'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/employment')
                       }
                       if (window.App.urlVars().update === 'employment' || window.App.urlVars().create === 'employment') {
                         history.push('/hr/' + entity + '/' + action + '/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('employmentUpdate') : t('employmentCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/employment')
                      }
                      if (window.App.urlVars().update === 'employment' || window.App.urlVars().create === 'employment') {
                        history.push('/hr/' + entity + '/' + action + '/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <EmploymentFormComponent backlink={'/hr/employment'}/>
                  }
                  {(window.App.urlVars().update === 'employment' || window.App.urlVars().create === 'employment') &&
                    <EmploymentFormComponent backlink={'/hr/' + entity + '/' + action + '/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'employee' && action === 'read' &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  {localStorage.getItem('breadcrumb') ? (
                    <BreadCrumb model={JSON.parse(localStorage.getItem('breadcrumb'))}
                                home={{icon: 'pi pi-home', url: '/'}}/>
                  ) : (
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('employeeShow')}
                    </h2>
                  )}
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <EmployeeDeactivateButton key={id} employeeId={id}
                    employee={String(employeeData?.id) === String(id) ? employeeData : null}
                    onDeactivated={() => setEmployeeData(current => ({...current, active: false}))} t={t}/>
                  <a onClick={() => {
                    history.push('/hr/employee')
                  }}
                     className={"p-button  p-button-secondary p-ml-2"}>
                    <i className={"pi pi-arrow-left"}></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>
              <Panel>
                <TabView className="tabview-header-icon menu" style={{backgroundColor: 'white', border: 'none'}}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-4"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('tabPersonalData')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-ml-2"
                                    label={t('editData')} tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      history.push('/hr/employee/read/' + id + '?update=employee')
                                    }}/>
                          </div>
                        </div>
                        <EmployeeShowComponent onLoaded={(employee) => {
                          setEmployeeData(employee);
                          const dId = employee?.dashboard_id ?? employee?.dashboard?.id ?? null;
                          setEmployeeDashboardId(dId);
                        }}/>
                      </div>
                      <div className={"p-col-12 p-lg-8"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('tabEmployment')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                            <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                    label={t('addEmployment')} tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      history.push('/hr/employee/read/' + id + '?create=employment&employeeId=' + id)
                                    }}/>
                          </div>
                        </div>
                        <EmploymentListComponent/>
                        {(localStorage.getItem('roles') || '').includes('role_employee_read') &&
                          <EmployeeRecordsComponent key={`addresses-${id}`} employeeId={id} kind="addresses"/>}
                      </div>
                    </div>
                  </TabPanel>
                  {(localStorage.getItem('roles') || '').includes('role_employee_read') &&
                    <TabPanel header={t('employeeHistory.title')} leftIcon="pi pi-history">
                      <EmployeeHistoryComponent key={id}/>
                    </TabPanel>
                  }
                  {(localStorage.getItem('roles') || '').includes('role_employee_read') &&
                    <TabPanel header={t('employeeRecords.notes')} leftIcon="pi pi-comment">
                      <EmployeeRecordsComponent key={`notes-${id}`} employeeId={id} kind="notes"/>
                    </TabPanel>}
                  <TabPanel header={t('tabDocuments')} leftIcon="pi pi-file">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('employeeDocuments')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                label={t('addDocumentFromTemplate')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/hr/employee/read/' + id + '?create=docs')
                                }}/>
                        <Button icon="pi pi-upload" className="p-button-success p-button-sm p-ml-2"
                                label={t('uploadDocument')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/hr/employee/read/' + id + '?upload=docs')
                                }}/>
                      </div>
                    </div>
                    <DocsListComponent/>
                  </TabPanel>
                  <TabPanel header={t('tabWorkFitness')} leftIcon="pi pi-check-circle">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('tabWorkFitnessEntries')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <SplitButton
                          ref={complianceSplitButtonRef}
                          icon="pi pi-plus"
                          className="p-button-success p-button-sm p-ml-2"
                          label={t('addEntry')}
                          model={compilanceCategory.map(category => ({
                            label: category.name,
                            command: () => {
                              history.push(
                                '/hr/employee/read/' +
                                id +
                                '?create=compilance&employeeId=' +
                                id +
                                '&categoryId=' +
                                category.id
                              );
                            }
                          }))}
                          tooltipOptions={{position: 'left'}}
                          onClick={(e) => {
                            const menuButton = complianceSplitButtonRef.current
                              ?.getElement()
                              ?.querySelector('.p-splitbutton-menubutton');
                            menuButton?.click();
                          }}
                        />
                      </div>
                    </div>
                    <CompilanceListComponent/>
                  </TabPanel>
                  <TabPanel header={t('tabCalendar')} leftIcon="pi pi-calendar-times">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('tabWorkCalendar')}
                        </h3>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                        <Button icon="pi pi-plus" className="p-button-success p-button-sm p-ml-2"
                                label={t('addEntry')} tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  history.push('/hr/employee/read/' + id + '?create=calendar&employeeId=' + id)
                                }}/>
                      </div>
                    </div>
                    <CalendarComponent/>
                  </TabPanel>
                  <TabPanel header={t('tabWagePayments')} leftIcon="pi pi-euro">
                    <PayrollentryListComponent employeeId={id} />
                  </TabPanel>
                  <TabPanel header={t('tabUserAccount')} leftIcon="pi pi-user">
                    <EmployeeUserAccountComponent employeeId={id}/>
                  </TabPanel>
                  {hasRole('ROLE_EMPLOYEE_DASHBOARD') && <TabPanel header={t('tabReport')} leftIcon="pi pi-chart-bar">
                    <HrDashboardComponent
                      key={employeeDashboardId || 'employee-dashboard-empty'}
                      dashboardId={employeeDashboardId}
                      allowRouteIdFallback={false}
                    />
                  </TabPanel>}
                </TabView>
              </Panel>
            </div>
          }
          {entity === 'employment' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_employment_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('employmentModeList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_employment_write') && (
                    <a onClick={() => {
                      history.push('/hr/employment/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEmploymentMode')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <EmploymentListComponent backlink={'/hr/employment'}/>
              </Panel>
            </div>
          }
          {entity === 'employment-type' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_employment_type_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('employmentTypeList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_employment_type_write') && (
                    <a onClick={() => {
                      history.push('/hr/employment-type/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEmploymentType')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <EmploymenttypeListComponent backlink={'/hr/employment-type'}/>
              </Panel>
            </div>
          }
          {entity === 'employment-type' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/employment-type')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('employmentTypeUpdate') : t('employmentTypeCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/employment-type')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <EmploymenttypeFormComponent backlink={'/hr/employment-type'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'employee-position' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_employee_position_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('employeePositionList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_employee_position_write') && (
                    <a onClick={() => {
                      history.push('/hr/employee-position/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEmployeePosition')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <EmployeepositionListComponent backlink={'/hr/employee-position'}/>
              </Panel>
            </div>
          }
          {entity === 'employee-position' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/employee-position')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('employeePositionUpdate') : t('employeePositionCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/employee-position')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <EmployeepositionFormComponent backlink={'/hr/employee-position'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'citizenship' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_citizenship_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('citizenshipList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_citizenship_write') && (
                    <a onClick={() => {
                      history.push('/hr/citizenship/create')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('citizenshipCreate')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CitizenshipListComponent backlink={'/hr/citizenship'}/>
              </Panel>
            </div>
          }
          {entity === 'citizenship' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/citizenship')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('citizenshipUpdate') : t('citizenshipCreatePlain')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/citizenship')
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <CitizenshipFormComponent backlink={'/hr/citizenship'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'calendar' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_hr_calendar_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('calendar')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  <Button
                    type="button"
                    label={t('detailedSearch')}
                    icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                    className="p-button-outlined p-mr-2"
                    onClick={() => setDetailedSearchVisible(v => !v)}
                  />
                  {localStorage.getItem('roles').toString().includes('role_hr_calendar_write') && (
                    <a onClick={() => {
                      history.push('/hr/calendar/create')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addEntry')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CalendarComponent detailedSearchVisible={detailedSearchVisible}
                  onDetailedSearchVisibleChange={setDetailedSearchVisible}
                  onDetailedSearchActiveChange={setDetailedSearchActive}
                  backlink={'/hr/calendar'}/>
              </Panel>
            </div>
          }
          {((entity === 'calendar' && (action === 'create' || action === 'update'))
              || (entity === 'employee' && (window.App.urlVars().create === 'calendar' || window.App.urlVars().update === 'calendar'))) &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'calendar' || window.App.urlVars().update === 'calendar'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/calendar')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('calendarEntryUpdate') : t('calendarEntryCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'calendar' && (action === 'create' || action === 'update')) {
                        history.push('/hr/calendar')
                      }
                      if (entity === 'employee') {
                        history.push('/hr/employee/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <CalendarFormComponent backlink={'/hr/calendar'}/>
                  }
                  {entity === 'employee' &&
                    <CalendarFormComponent backlink={-1}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'calendar-category' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_hr_calendar_category_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('categoryList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_hr_calendar_category_write') && (
                    <a onClick={() => {
                      history.push('/hr/calendar-category/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addCategory')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CalendarcategoryListComponent backlink={'/hr/calendar-category'}/>
              </Panel>
            </div>
          }
          {(entity === 'calendar-category' || entity === 'bla') && (action === 'create' || action === 'update'
              || window.App.urlVars().create === 'calendar-category' || window.App.urlVars().update === 'calendar-category') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'calendar-category' || window.App.urlVars().update === 'calendar-category'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/calendar-category')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('calendarCategoryUpdate') : t('calendarCategoryCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'calendar-category' && (action === 'create' || action === 'update')) {
                        history.push('/hr/calendar-category')
                      }
                      if (entity === 'bla') {
                        history.push('/hr/bla/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <CalendarcategoryFormComponent backlink={'/hr/calendar-category'}/>
                  }
                  {entity === 'bla' &&
                    <></>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'docs' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_hr_docs_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('documentList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                </div>
              </div>
              <Panel>
                <DocsListComponent backlink={'/hr/docs'}/>
              </Panel>
            </div>
          }
          {(entity === 'docs' && (action === 'create' || action === 'update'))
            || (entity === 'employee' && (window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs')) &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update'
                       || window.App.urlVars().create === 'docs' || window.App.urlVars().update === 'docs'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/docs')
                       }
                       if (entity === 'employee') {
                         history.push('/hr/employee/read/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('fromDocumentTemplate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'docs' && (action === 'create' || action === 'update')) {
                        history.push('/hr/docs')
                      }
                      if (entity === 'employee') {
                        history.push('/hr/employee/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <DocsFormComponent backlink={'/hr/docs'}/>
                  }
                  {entity === 'employee' &&
                    <DocsFormComponent backlink={'/hr/employee/read/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {(entity === 'docs' && (action === 'create' || action === 'update')) || (entity === 'employee' && window.App.urlVars().upload === 'docs') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().upload === 'docs'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/docs')
                       }
                       if (entity === 'employee') {
                         history.push('/hr/employee/read/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('documentUpload')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'docs' && (action === 'create' || action === 'update')) {
                        history.push('/hr/docs')
                      }
                      if (entity === 'employee') {
                        history.push('/hr/employee/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <DocsUploadComponent backlink={'/hr/docs'}/>
                  }
                  {entity === 'employee' &&
                    <DocsUploadComponent backlink={'/hr/employee/read/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'compilance' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_compilance_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('complianceList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_compilance_write') && (
                    <a onClick={() => {
                      history.push('/hr/compilance/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addWorkFitnessEntry')}
                    </a>
                  )}
                </div>
              </div>
              <Panel>
                <CompilanceListComponent backlink={'/hr/compilance'}/>
              </Panel>
            </div>
          }
          {((entity === 'compilance' && (action === 'create' || action === 'update')) || (entity === 'employee' && (window.App.urlVars().create === 'compilance' || window.App.urlVars().update === 'compilance'))) &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'compilance' || window.App.urlVars().update === 'compilance'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/compilance')
                       }
                       if (entity === 'employee') {
                         history.push('/hr/employee/read/' + id)
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('workFitnessEntryUpdate') : t('workFitnessEntryCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'compilance' && (action === 'create' || action === 'update')) {
                        history.push('/hr/compilance')
                      }
                      if (entity === 'employee') {
                        history.push('/hr/employee/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {entity === 'compilance' && (action === 'create' || action === 'update') &&
                    <CompilanceFormComponent backlink={'/hr/compilance'}/>
                  }
                  {entity === 'employee' &&
                    <CompilanceFormComponent backlink={'/hr/employee/read/' + id}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'compilance-category' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_compilance_category_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('complianceCategoryList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_compilance_category_write') && (
                    <a onClick={() => {
                      history.push('/hr/compilance-category/create')
                    }}
                       className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                    &nbsp;
                    {t('addCategory')}
                  </a>
                  )}
                </div>
              </div>
              <Panel>
                <CompilancecategoryListComponent backlink={'/hr/compilance-category'}/>
              </Panel>
            </div>
          }
          {(entity === 'compilance-category' || entity === 'bla') && (action === 'create' || action === 'update'
              || window.App.urlVars().create === 'compilance-category' || window.App.urlVars().update === 'compilance-category') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={action === 'create' || action === 'update' || window.App.urlVars().create === 'compilance-category' || window.App.urlVars().update === 'compilance-category'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       if (action === 'create' || action === 'update') {
                         history.push('/hr/compilance-category')
                       }
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('categoryUpdate') : t('categoryCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (entity === 'compilance-category' && (action === 'create' || action === 'update')) {
                        history.push('/hr/compilance-category')
                      }
                      if (entity === 'bla') {
                        history.push('/hr/bla/read/' + id)
                      }
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <CompilancecategoryFormComponent backlink={'/hr/compilance-category'}/>
                  }
                  {entity === 'bla' &&
                    <></>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'checkin' && localStorage.getItem('roles').toString().includes('role_checkin_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('checkinList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                    {localStorage.getItem('roles').toString().includes('role_checkin_import') && (
                      <a onClick={() => {
                        history.push('/hr/checkin?create=import')
                      }}
                         className={"p-button p-button-success p-ml-2"}>
                        <i className={"pi pi-upload"}></i>
                        &nbsp;
                        {t('importCreate')}
                      </a>
                    )}
                    {localStorage.getItem('roles').toString().includes('role_checkin_read') && (
                      <a onClick={() => {
                        history.push('/hr/checkin/create')
                      }}
                         className={"p-button  p-button-success p-ml-2"}>
                        <i className={"pi pi-plus"}></i>
                        &nbsp;
                        Export
                      </a>
                    )}
                  </span>
                </div>
              </div>
              <Panel>
                <CheckinListComponent backlink={'/hr/checkin'}/>
              </Panel>
            </div>
          }
          {entity === 'checkin' && window.App.urlVars().create === 'import' &&
            localStorage.getItem('roles').toString().includes('role_checkin_import') &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={true}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/hr/checkin')
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('importCreateAction')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <a onClick={() => {
                      history.push('/hr/checkin')
                    }}
                       className={"p-button p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ImportFormComponent
                    backlink={'/hr/checkin'}
                    importType={'checkin_daily_activity'}
                  />
                </Panel>
                <div className={"p-grid p-mt-4"}>
                  <div className={"p-col-12 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('importProcesses')}
                    </h2>
                  </div>
                </div>
                <Panel>
                  <ImportListComponent importType={'checkin_daily_activity'}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'checkin' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: 'min(1400px, 98vw)', maxWidth: '98vw'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/hr/checkin')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {/* Bérlista {id ? (<>módosítása</>) : (<>létrehozása</>)} */}
                      {t('exportCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/checkin/export')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <CheckinexportFormComponent backlink={'/hr/checkin/export'}/>
                  }
                </Panel>
              </div>
              {(action === 'create' || action === 'update') &&
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('exportProcesses')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>

                    </span>
                      {/* <a onClick={() => {
                        history.push('/hr/payroll/update/' + id + '?create=import')
                      }}
                         className={"p-button  p-button-success p-ml-2"}>
                        <i className={"pi pi-plus"}></i>
                        &nbsp;
                        {t('importCreate')}
                      </a> */}
                    </div>
                  </div>
                  <Panel>
                    <CheckinexportListComponent  />
                  </Panel>
                </div>
              }
            </Sidebar>
          }
          {entity === 'payroll' && (!action || action === 'update' || action === 'create'|| action === 'export-daily' || action === 'export-monthly') && localStorage.getItem('roles').toString().includes('role_payroll_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-3 p-col-align-center p-text-center p-text-lg-left"}>
                  <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('payrollList')}
                  </h2>
                </div>
                <div className={"p-col-12 p-lg-9 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_payroll_write') && (
                    <>
                      <a onClick={() => {
                        history.push('/hr/payroll/export-daily')
                      }}
                          className={"p-button  p-button-success p-ml-2"}>
                        <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('dailyWorkingTimeExport')}
                    </a>
                    <a onClick={() => {
                      history.push('/hr/payroll/export-monthly')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('monthlyWorkingTimeExport')}
                    </a>
                    <a onClick={() => {
                      history.push('/hr/payroll/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addPayroll')}
                    </a>
                  </>
                  )}
                </div>
              </div>
              <Panel>
                <PayrollListComponent backlink={'/hr/payroll'}  entity="payroll"/>
              </Panel>
            </div>
          }
          {entity === 'payroll' && action === 'read' && (
            <div className="PageContent p-p-5 p-mx-auto">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {payroll?.company?.name ?? ''}
                  </h2>
                </div>
    
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                  <a
                    onClick={() => {
                      history.push('/hr/payroll');
                    }}
                    className="p-button p-button-secondary p-ml-2"
                  >
                    <i className="pi pi-arrow-left"></i>
                    &nbsp;
                    {t('back')}
                  </a>
                </div>
              </div>
    
              <Panel>
                <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{border: 'none'}}>
                  <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('columnName')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                          </div>
                        </div>
                        <PayrollShowComponent view={window.App.urlVars().view} entity={'payroll'}  backlink={'/hr/payroll'} onLoaded={(payroll) => setPayroll(payroll || {})} />
                      </div>
                      <div className={"p-col-12 p-lg-6"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className="p-m-0" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '0.5rem' }}>
                              <i className="pi pi-list p-mr-2"></i> {t('costAllocation')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                          </div>
                        </div>
                        {financePermissions().readAllocations && <PayrollCostallocationListComponent view={window.App.urlVars().view} entity={'payroll'}  backlink={'/hr/payroll'} />}
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header={t('tabImport')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                        <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                          {t('importProcesses')}
                        </h2>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <span className={"p-mr-2"}>

                      </span>
                      {payrollData && !payrollData.closed && (
                        <a onClick={() => {
                          history.push('/hr/payroll/read/' + id + '?create=import')
                        }}
                          className={"p-button  p-button-success p-ml-2"}>
                          <i className={"pi pi-plus"}></i>
                          &nbsp;
                          {t('importCreate')}
                        </a>
                      )}
                      </div>
                    </div>
                    <Panel>
                      <ImportListComponent importType={'payroll_hu_rlb'} isClosed={payrollData?.closed} />
                    </Panel>
                  </TabPanel>
                  <TabPanel header={t('tabItems')} leftIcon="pi pi-list">
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-12"}>
                        <div className={"p-grid"}>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                            <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                              {t('tabItems')}
                            </h3>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                          </div>
                        </div>
                        <PayrollitemListComponent view={window.App.urlVars().view} entity={'payroll'}  backlink={'/hr/payroll'} />
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
              </Panel>
            </div>
          )}
          {entity === 'payroll' && (action === 'export-daily' || action === 'export-monthly') &&
            <Sidebar position="left"
                    showCloseIcon={false}
                    visible={true}
                    closeOnEscape={true}
                    style={{width: '780px'}}
                    onHide={() => history.push('/hr/payroll')}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-8 p-col-align-center"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {action === 'export-daily' ? t('dailyWorkingTimeExportDetailed') : t('monthlyWorkingTimeExportDetailed')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-4 p-col-align-center p-text-right"}>
                    <a onClick={() => history.push('/hr/payroll')} className={"p-button p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>&nbsp;{t('back')}
                    </a>
                  </div>
                </div>
                <Panel className="p-mt-3">
                  <PayrollexportFormComponent 
                      type={action === 'export-daily' ? 'daily' : 'monthly'} 
                      backlink={'/hr/payroll'} 
                      goback={false}
                  />
                </Panel>
                <div className={"p-grid p-mt-5"}>
                  <div className={"p-col-12"}>
                    <h2 className={"p-m-0 p-p-0 text-primary"}>{t('exportProcesses')}</h2>
                  </div>
                </div>
                <Panel className="p-mt-3">
                  <PayrollexportListComponent 
                      type={action === 'export-daily' ? 'daily' : 'monthly'} 
                  />
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'payroll' && (action === 'create' || action === 'update') &&
            <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'create' || action === 'update'}
                      closeOnEscape={true}
                      style={{width: '780px'}}
                      onHide={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/hr/payroll')
                        }
                      }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {id ? t('payrollUpdate') : t('payrollCreate')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                    <a onClick={() => {
                      if (action === 'create' || action === 'update') {
                        history.push('/hr/payroll')
                      }
                    }}
                        className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  {(action === 'create' || action === 'update') &&
                    <PayrollFormComponent backlink={'/hr/payroll'}/>
                  }
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'payroll' && window.App.urlVars().create === 'import' &&
            <Sidebar position="left"
                     showCloseIcon={false}
                     visible={window.App.urlVars().create === 'import'}
                     closeOnEscape={true}
                     style={{width: '780px'}}
                     onHide={() => {
                       history.push('/hr/payroll/read/' + id)
                     }}>
              <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('importCreateAction')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>
                  </span>
                    <a onClick={() => {
                      history.push('/hr/payroll/read/' + id)
                    }}
                       className={"p-button  p-button-secondary p-ml-2"}>
                      <i className={"pi pi-arrow-left"}></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <ImportFormComponent backlink={'/hr/payroll/read/' + id} importType={'payroll_hu_rlb'} relatedEntityId={id}/>
                </Panel>
              </div>
            </Sidebar>
          }
          {entity === 'simplified-employment' && (!action || action === 'update' || action === 'create') && localStorage.getItem('roles').toString().includes('role_simplified_employment_read') &&
            <div className={"PageContent p-p-5 p-mx-auto"}>
              <SimplifiedEmploymentListComponent/>
            </div>
          }
          <Sidebar position="bottom"
                   visible={window.App.urlVars().search === 'partner'}
                   closeOnEscape={true}
                   style={{width: '100%', height: '80%'}}
                   onHide={() => {
                     history.push('/hr/' + entity + '/' + action + '/' + id)
                   }}>
            <div className={"p-grid p-mt-3"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('partnerSearch')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

              </div>
            </div>
            <Panel>
              <PartnerListComponent view={"search"} backlink={'/hr/' + entity + '/' + action + '/' + id}/>
            </Panel>
          </Sidebar>
          <Dialog visible={window.App.urlVars().create === 'partner'}
                  style={{width: '980px'}}
                  header={t('partnerCreate')}
                  modal
                  onHide={() => {
                    history.push('/hr/' + entity + '/' + action + '/' + id)
                  }}>
            <PartnerFormComponent backlink={'/hr/' + entity + '/' + action + '/' + id}/>
          </Dialog>

          {/* compilance-category/create employee search */}
          <Sidebar
            position="bottom"
            visible={window.App.urlVars().search === 'employee'}
            closeOnEscape={true}
            style={{ width: '100%', height: '80%' }}
            onHide={() => {
              const vars = window.App.urlVars();
              const cleanedVars = { ...vars };
              delete cleanedVars.search;
              let query = '?';
              Object.entries(cleanedVars).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                  query += key + '=' + value + '&';
                }
              });
              history.push(baseHrPath + query);
            }}
          >
            <div className="p-grid p-mt-3">
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                  {t('employeeSearch')}
                </h3>
              </div>
              <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
              </div>
            </div>

            <Panel>
              <EmployeeListComponent
                view="search"
                backlink={baseHrPath}
              />
            </Panel>
          </Sidebar>
        </>
      ) : (
        <p className={"p-text-center p-my-5 p-py-5"}>
          <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
          <span className={"p-text-bold p-d-block "}>{t('moduleNoAccess')}</span>
          {t('moduleNoAccessContact')} {process.env.REACT_APP_DEVOPS_CONTACT} {t('emailAddressSuffix')}
          {process.env.REACT_APP_SUBSCRIPTIONS === 'enabled' &&
            <span className={"p-text-bold p-d-block p-mt-5"}>
                       <a className={"p-button p-button-warning"}
                          onClick={() => {
                            window.location.replace('/#/subscriptions');
                            window.App.forceUpdate()
                          }}
                       >
                         <i className={"pi pi-building"}></i>&nbsp;{t('subscriptionAccountOverview')}
                       </a>
                   </span>
          }
        </p>
      )
      }
    </div>
  )
}
export default withTranslation('common')(HrPage);
